import React, { useEffect, useState, useRef } from "react";
import ReactDOM from "react-dom";
import "./ImageGallery.css";



const ImageGallery = () => {
  const [folderImages, setFolderImages] = useState({});
  const sliderRefs = useRef({});
  const [selectedImage, setSelectedImage] = useState(null);
  useEffect(() => {
  if (selectedImage) {
    document.body.style.overflow = "hidden";
  } else {
    document.body.style.overflow = "auto";
  }
}, [selectedImage]);


  const marathiNames = {
    ShikshanSanstha: "शिक्षण संस्था",
    academic: "शैक्षणिक",
    cropShop: "कॉप शॉप",
    iec: "माहिती शिक्षण व संवाद",
    training: "प्रशिक्षण",
    bahumajliGruhsankule: "बहुमजली गृहसंकुले",
    demoHouseDistrict: "डेमो हाऊस जिल्हा",
    landBank: "लँड बँक",
    workshopCapacityBuild: "क्षमता बांधणी कार्यशाळा",
    bahumajliImarti: "बहुमजली इमारती",
    demoHouseTaluka: "डेमो हाऊस तालुका",
    masonTraining: "गवंडी प्रशिक्षण",
    beneficiaryMelava: "लाभार्थी मेळावा",
    gharkulMart: "घरकुल मार्ट",
    ngo: "एनजीओ सहभाग",
    corporate: "कॉर्पोरेट",
    gruhsankule: "गृहसंकुले",
    sandBank: "सॅण्ड बँक",
  };

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/imageGallary/images`)
      .then((res) => res.json())
      .then((data) => setFolderImages(data))
      .catch((err) => console.error("Failed to fetch images:", err));
  }, []);

  const slideLeft = (folderName) => {
    sliderRefs.current[folderName]?.scrollBy({
      left: -sliderRefs.current[folderName].offsetWidth / 5,
      behavior: "smooth",
    });
  };

  const slideRight = (folderName) => {
    sliderRefs.current[folderName]?.scrollBy({
      left: sliderRefs.current[folderName].offsetWidth / 5,
      behavior: "smooth",
    });
  };

  return (
    <div className="gallery-container container">
      {Object.entries(folderImages).map(([folderName, images]) => (
        <div className="folder-section mb-5" key={folderName}>
          <h5 className="folder-title text-center mb-4">
            {marathiNames[folderName] || folderName}
          </h5>

          <div className="slider-wrapper">
            <button
              onClick={() => slideLeft(folderName)}
              className="slider-control-prev"
            >
              <span className="carousel-control-prev-icon" />
            </button>

            <div
              className="image-slider"
              ref={(el) => (sliderRefs.current[folderName] = el)}
            >
              {images.map((imgUrl, idx) => (
                <div
                  className="slider-image-wrapper"
                  key={idx}
                  onClick={() =>
                    setSelectedImage(`${process.env.REACT_APP_API_URL}${imgUrl}`)
                  }
                >
                  <img
                    src={`${process.env.REACT_APP_API_URL}${imgUrl}`}
                    alt={`img-${idx}`}
                    className="slider-image"
                  />
                </div>
              ))}
            </div>

            <button
              onClick={() => slideRight(folderName)}
              className="slider-control-next"
            >
              <span className="carousel-control-next-icon" />
            </button>
          </div>
        </div>
      ))}

 {selectedImage &&
  ReactDOM.createPortal(
    <div
      className="image-popup-overlay"
      onClick={() => setSelectedImage(null)}
    >
      <div
        className="image-popup-content"
        onClick={(e) => e.stopPropagation()}
      >
        <span
          className="close-btn"
          onClick={() => setSelectedImage(null)}
        >
          &times;
        </span>
        <img src={selectedImage} alt="Preview" />
      </div>
    </div>,
    document.body
  )}


    </div>
  );
};

export default ImageGallery;





